/// variations
(function () {
  document.addEventListener("DOMContentLoaded", async () => {
    const container = document.getElementById("rk_variations_container");
    if (!container) return;
    const group = container.dataset.groupe;
    const currentHandle = container.dataset.productHandle;

    if (!group) return;

    const query = `
      query MyQuery {
            products(first: 100, query: "${group}") {
              edges {
                node {
                  title
                  handle
                  onlineStoreUrl
                  metafields(identifiers: [
                    { namespace: "custom", key: "groupe_de_variation" },
                    { namespace: "shopify", key: "color-pattern" }
                  ]) {
                    namespace
                    key
                    value
                    references(first: 5) {
                      edges {
                        node {
                          ... on Metaobject {
                            fields {
                            reference {
                        ... on MediaImage {
                          image {
                            url
                          }
                        }
                      }
                              key
                              value
                            }
                          }
                        
                        }
                      }
                    }
                  }
                }
              }
          }
        }

    `;

    const res = await fetch("/api/2025-04/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "7e2bed5ca604754914ae039333de8b8a",
      },
      body: JSON.stringify({ query }),
    });

    const result = await res.json();
    const products = result.data.products.edges.map((edge) => edge.node);

    const grid = document.getElementById("rk_variations_grid");
    grid.innerHTML = "";

    products.forEach((p) => {
      const metafields = p.metafields || [];

      const groupe = metafields.find(
        (f) => f?.key === "groupe_de_variation"
      )?.value;
      if (!groupe || groupe !== group || p.handle === currentHandle) return;

      const colorField = metafields.find((f) => f?.key === "color-pattern");
      const colorRefs = colorField?.references?.edges || [];

      const div = document.createElement("div");
      div.className = "grouped-product-item";

      const a = document.createElement("a");
      a.href = p.onlineStoreUrl || `/products/${p.handle}`;
      a.className = "rk_img_variation";

      // Ajouter les pastilles de couleur
      colorRefs.forEach((ref) => {
        const fields = ref.node.fields || [];
        const color = fields.find((f) => f.key === "color")?.value;
        const image_replace = fields.find((f) => f.key === "image")?.reference
          .image.url;
        const label = p.title;

        if (color) {
          const swatch = document.createElement("div");
          swatch.style.backgroundColor = color;
          swatch.title = label || "";
          a.appendChild(swatch);
        } else if (image_replace) {
          const swatch = document.createElement("div");
          swatch.style.backgroundImage = "url(" + image_replace + ")";
          swatch.style.backgroundSize = "cover";
          swatch.style.transform = "rotate(-45deg)";
          swatch.title = label || "";
          a.appendChild(swatch);
        }
      });

      const pTitle = document.createElement("p");
      pTitle.textContent = p.title;
      a.appendChild(pTitle);

      div.appendChild(a);
      grid.appendChild(div);
    });
  });
})();
